import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@beef/ui-kit';
import { getActionBarTitle } from "../../../../store/actionBarWithBackCall/selectors";
import { toTelHref } from "../../../../utils";
import { handlePhoneClick } from "../../../../store/actionBarWithBackCall/actions";
var _TitleWithAnalytic = function _TitleWithAnalytic(props) {
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    "data-t-id": "components-Title"
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getActionBarTitle(state),
    extraAttributes: {
      style: {
        color: '#1790ff'
      }
    },
    href: toTelHref(getActionBarTitle(state)),
    isNoUnderline: true
  };
};
var mapDispatchToProps = {
  onClick: handlePhoneClick
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var TitleWithAnalytic = connector(_TitleWithAnalytic);